import {
    detect
} from "detect-browser";

/**
 * This class is used to open a new tab in a browser. It detects if the new tab needs to be opened during the onClick event.
 * For instance, Firefox and Safari require the new tab to be opened during the onClick event, otherwise the new tab will be blocked.
 * On other browsers the tab is opened during the open function call to prevent having the user staring at a blank page for a few seconds.
 */
class NewTabOpener {
    window: Window | null = null;

    constructor() {
        if(!this.shouldPreOpenWindow()) {
            return;
        }
        this.preOpenWindow();
    }

    shouldPreOpenWindow() {
        const browser = detect();
        if(!browser) {
            return false;
        }
        console.log("Detected browser: " + browser.name);
        switch(browser.name) {
            case "firefox":
            case "safari":
            case "ios":
                return true;
            default:
                return false;
        }
    }

    preOpenWindow() {
        this.window = window.open("about:blank", "_blank");
    }

    open(url: string) {
        if(this.window) {
            this.window.location = url;
        } else {
            this.window = window.open(url, "_blank");
        }
        this.window?.focus();
        this.window = null;
    }

}

export default NewTabOpener;
